var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHeroImgIbmLogo = function SvgHeroImgIbmLogo(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1150px",
    height: "456px",
    viewBox: "0 0 1148 456",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 0.382812 15.117188 L 0.382812 30.234375 L 211.664062 30.234375 L 211.664062 0 L 0.382812 0 Z M 0.382812 15.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 241.84375 15.117188 L 241.84375 30.234375 L 564.652344 30.234375 L 562.441406 28.390625 C 558.246094 24.851562 544.921875 16.148438 539.769531 13.492188 C 526.882812 7.003906 509.730469 2.0625 495.449219 0.734375 C 490.296875 0.296875 442.449219 0 364.636719 0 L 241.84375 0 Z M 241.84375 15.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 634.21875 15.117188 L 634.21875 30.234375 L 731.761719 30.234375 C 809.351562 30.234375 829.300781 30.011719 829.226562 29.277344 C 829.226562 28.832031 826.945312 22.046875 824.222656 14.378906 L 819.214844 0.371094 L 726.75 0.144531 L 634.21875 0 Z M 634.21875 15.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 961.734375 1.992188 C 960.78125 4.570312 952.238281 29.644531 952.238281 29.9375 C 952.238281 30.089844 996.113281 30.234375 1049.78125 30.234375 L 1147.324219 30.234375 L 1147.324219 0 L 962.546875 0 Z M 961.734375 1.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 0.382812 75.953125 L 0.382812 90.699219 L 211.664062 90.699219 L 211.664062 61.203125 L 0.382812 61.203125 Z M 0.382812 75.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 241.84375 75.953125 L 241.84375 90.699219 L 418.15625 90.699219 C 548.824219 90.699219 594.464844 90.476562 594.464844 89.886719 C 594.464844 87.824219 589.53125 74.917969 586.292969 68.355469 L 582.6875 61.203125 L 241.84375 61.203125 Z M 241.84375 75.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 634.21875 75.953125 L 634.21875 90.699219 L 850.574219 90.699219 L 845.644531 76.101562 L 840.636719 61.570312 L 737.429688 61.347656 L 634.21875 61.203125 Z M 634.21875 75.953125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 936.414062 74.992188 C 933.6875 82.664062 931.261719 89.300781 931.113281 89.738281 C 930.816406 90.476562 952.679688 90.699219 1039.03125 90.699219 L 1147.324219 90.699219 L 1147.324219 61.203125 L 941.347656 61.203125 Z M 936.414062 74.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 60.75 136.785156 L 60.75 151.898438 L 151.296875 151.898438 L 151.296875 121.671875 L 60.75 121.671875 Z M 60.75 136.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 302.207031 136.785156 L 302.207031 151.898438 L 392.753906 151.898438 L 392.753906 121.671875 L 302.207031 121.671875 Z M 302.207031 136.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 483.304688 136.785156 L 483.304688 151.898438 L 590.714844 151.898438 L 591.449219 149.101562 C 592.550781 144.96875 594.316406 133.023438 594.757812 126.976562 L 595.128906 121.671875 L 483.304688 121.671875 Z M 483.304688 136.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 694.582031 136.785156 L 694.582031 151.898438 L 871.925781 151.898438 L 867.800781 140.253906 C 865.59375 133.90625 863.238281 127.125 862.578125 125.132812 L 861.398438 121.671875 L 694.582031 121.671875 Z M 694.582031 136.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 920.21875 122.328125 C 919.996094 122.773438 918.007812 128.15625 915.875 134.351562 C 913.664062 140.546875 911.382812 147.035156 910.722656 148.730469 L 909.617188 151.898438 L 1086.957031 151.898438 L 1086.957031 121.671875 L 1003.84375 121.671875 C 952.902344 121.671875 920.511719 121.964844 920.21875 122.328125 Z M 920.21875 122.328125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 60.75 197.253906 L 60.75 212.367188 L 151.296875 212.367188 L 151.296875 182.132812 L 60.75 182.132812 Z M 60.75 197.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 302.207031 197.253906 L 302.207031 212.367188 L 554.34375 212.367188 L 561.5625 205.140625 C 568.257812 198.503906 575.324219 189.804688 578.492188 184.421875 L 579.816406 182.132812 L 302.207031 182.132812 Z M 302.207031 197.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 694.582031 197.253906 L 694.582031 212.367188 L 785.132812 212.367188 L 785.28125 199.019531 L 785.496094 185.675781 L 794.921875 212.367188 L 890.625 212.222656 L 986.324219 212 L 991.183594 198.722656 L 996.042969 185.453125 L 996.261719 198.875 L 996.410156 212.367188 L 1086.957031 212.367188 L 1086.957031 182.132812 L 899.382812 182.132812 L 897.46875 187.445312 C 896.4375 190.394531 894.449219 195.996094 893.125 199.832031 C 890.988281 205.878906 890.546875 206.542969 890.035156 204.992188 C 889.738281 203.960938 887.828125 198.429688 885.835938 192.605469 L 882.15625 182.132812 L 694.582031 182.132812 Z M 694.582031 197.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 60.75 258.453125 L 60.75 273.570312 L 151.296875 273.570312 L 151.296875 243.335938 L 60.75 243.335938 Z M 60.75 258.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 302.207031 258.453125 L 302.207031 273.570312 L 441.046875 273.570312 C 551.839844 273.570312 579.742188 273.347656 579.300781 272.609375 C 574.515625 264.574219 567.964844 256.535156 559.421875 248.28125 L 554.195312 243.335938 L 302.207031 243.335938 Z M 302.207031 258.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 694.582031 258.453125 L 694.582031 273.570312 L 785.132812 273.570312 L 785.132812 243.335938 L 694.582031 243.335938 Z M 694.582031 258.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 808.097656 244.222656 C 808.320312 244.738281 810.898438 251.59375 813.839844 259.414062 L 819.289062 273.570312 L 890.625 273.421875 L 962.03125 273.199219 L 966.304688 262.140625 C 968.726562 256.019531 971.304688 249.308594 972.117188 247.171875 L 973.589844 243.335938 L 890.695312 243.335938 C 824.667969 243.335938 807.878906 243.558594 808.097656 244.222656 Z M 808.097656 244.222656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 996.410156 258.453125 L 996.410156 273.570312 L 1086.957031 273.570312 L 1086.957031 243.335938 L 996.410156 243.335938 Z M 996.410156 258.453125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 60.75 318.917969 L 60.75 334.035156 L 151.296875 334.035156 L 151.296875 303.804688 L 60.75 303.804688 Z M 60.75 318.917969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 302.207031 318.917969 L 302.207031 334.035156 L 392.753906 334.035156 L 392.753906 303.804688 L 302.207031 303.804688 Z M 302.207031 318.917969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 483.304688 318.917969 L 483.304688 334.035156 L 595.128906 334.035156 L 594.757812 328.65625 C 594.316406 322.683594 592.550781 310.734375 591.449219 306.53125 L 590.714844 303.804688 L 483.304688 303.804688 Z M 483.304688 318.917969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 694.582031 318.917969 L 694.582031 334.035156 L 785.132812 334.035156 L 785.132812 303.804688 L 694.582031 303.804688 Z M 694.582031 318.917969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 831.511719 304.023438 C 831.511719 304.101562 834.082031 310.808594 837.25 318.917969 L 843.070312 333.671875 L 938.476562 333.671875 L 944.214844 318.917969 C 947.378906 310.808594 950.03125 304.101562 950.03125 303.953125 C 950.03125 303.878906 923.382812 303.804688 890.769531 303.804688 C 858.160156 303.804688 831.511719 303.878906 831.511719 304.023438 Z M 831.511719 304.023438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 996.410156 318.917969 L 996.410156 334.035156 L 1086.957031 334.035156 L 1086.957031 303.804688 L 996.410156 303.804688 Z M 996.410156 318.917969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 0.382812 379.753906 L 0.382812 394.503906 L 211.664062 394.503906 L 211.664062 365.007812 L 0.382812 365.007812 Z M 0.382812 379.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 241.84375 379.753906 L 241.84375 394.503906 L 412.339844 394.355469 L 582.910156 394.132812 L 586.144531 387.714844 C 589.460938 381.082031 593.136719 371.570312 594.097656 367.367188 L 594.613281 365.007812 L 241.84375 365.007812 Z M 241.84375 379.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 634.21875 379.753906 L 634.21875 394.503906 L 785.132812 394.503906 L 785.132812 365.007812 L 634.21875 365.007812 Z M 634.21875 379.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 860.957031 379.53125 L 866.621094 394.132812 L 915.0625 394.132812 L 920.65625 379.53125 L 926.328125 365.007812 L 855.289062 365.007812 Z M 860.957031 379.53125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 996.410156 379.753906 L 996.410156 394.503906 L 1147.324219 394.503906 L 1147.324219 365.007812 L 996.410156 365.007812 Z M 996.410156 379.753906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 0.382812 440.589844 L 0.382812 455.703125 L 211.664062 455.703125 L 211.664062 425.472656 L 0.382812 425.472656 Z M 0.382812 440.589844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 241.84375 440.589844 L 241.84375 455.703125 L 365.375 455.703125 C 445.023438 455.703125 491.183594 455.410156 495.449219 454.96875 C 510.910156 453.195312 524.457031 449.4375 537.046875 443.464844 C 543.523438 440.367188 557.363281 431.589844 562.441406 427.3125 L 564.652344 425.472656 L 241.84375 425.472656 Z M 241.84375 440.589844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 634.21875 440.589844 L 634.21875 455.703125 L 785.132812 455.703125 L 785.132812 425.472656 L 634.21875 425.472656 Z M 634.21875 440.589844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 879.359375 426.136719 C 879.359375 427.019531 890.035156 454.15625 890.625 454.675781 C 890.769531 454.894531 893.640625 448.40625 896.882812 440.222656 L 902.769531 425.472656 L 891.066406 425.472656 C 884.21875 425.472656 879.359375 425.765625 879.359375 426.136719 Z M 879.359375 426.136719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(0%,0%,0%)",
      fillOpacity: 1
    },
    d: "M 996.410156 440.589844 L 996.410156 455.703125 L 1147.324219 455.703125 L 1147.324219 425.472656 L 996.410156 425.472656 Z M 996.410156 440.589844 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeroImgIbmLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/hero_img_ibm_logo.28d589d9.svg";
export { ForwardRef as ReactComponent };